import RedirectUI, { getPathNewUi } from 'guards/RedirectUI'
import React from 'react'
export default function DownloadHistory() {
  const path = getPathNewUi('/platform/priceVerify/downloadHistory')
  return <RedirectUI path={path} omitValidation={true} />
}
